import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

const capitalize = (str?: string) => str?.charAt(0).toUpperCase() + str?.slice(1);

@ModuleName("Membership")
export class Membership implements AxInit {
    constructor(
        private _axLoading = new AxLoading()
    ) { }

    AxInit(init?: { startPage: number }): void {
        $('[data-membership="tabs"] li a').on('show.bs.tab', (e) => {
            const link = $(e.delegateTarget).attr('data-membership-link');
            const action = `load${capitalize(link)}Info`;
            this._axLoading.ShowLoadingIndicator($(`[data-tabloading="${link}"]`)?.get(0));
            return ($(e.delegateTarget).is(`[data-membership-link="${link}"]`) && this[action]()) || undefined;
        });

        $('#tabs_1').on('click', '[data-membership-button="manage-membership"]', (e) => {
            const modalId = $(e.currentTarget).attr('data-value');
            this.getMembershipDetails(modalId)
        });

        $('#tabs_1').on('click', '[data-manage-modal-button="save"]', (e) => {
            const membershipId = $(e.currentTarget).attr('data-value');
            const $card = $(`input[name="ccRefSelection_${membershipId}"]:checked`)
            const tokenId = $card.data('cardno');
            const paymentMethod = $card.data('payment-method');
            this.updateToken(membershipId, tokenId, paymentMethod);
        });

        $('#tabs_1').on('click', '[data-manage-modal-button="discard"]', (e) => {
            const modalId = $(e.currentTarget).attr('data-value');
            $(`[data-manage-modal="${modalId}"]`).modal('hide');
        });

        $('#tabs_1').on('click', '[data-manage-modal-button="cancel"]', (e) => {
            const modalId = $(e.currentTarget).attr('data-value');
            const membershipName = $(e.currentTarget).attr('data-membership-name');
            const endDate = $(e.currentTarget).attr('data-membership-date');
            $('[data-manage-modal-button="back"]').attr('data-value', modalId)
            $('[data-manage-modal-button="confirm"]').attr('data-value', modalId)
            $('[data-cancel-modal-name=""]').text(membershipName)
            $('[data-cancel-modal-date=""]').text(endDate)
            $(`[data-manage-modal="${modalId}"]`).modal('hide');
            $(`[data-modal-cancel=""]`).modal('show');
        });

        $('#tabs_1').on('click', '[data-manage-modal-button="back"]', (e) => {
            const modalId = $(e.currentTarget).attr('data-value');
            $(`[data-modal-cancel=""]`).modal('hide');
            $(`[data-manage-modal="${modalId}"]`).modal('show');
        });

        $('#tabs_1').on('click', '[data-manage-modal-button="confirm"]', (e) => {
            const membershipId = $(e.currentTarget).attr('data-value');
            this.cancelMembership(membershipId);
        });

        $('#tabs_2').on('click', '[data-membership-payment="add"]', () => {
            this.addPayment();
        });

        $('#tabs_2').on('click', '[data-membership-payment="delete"]', (e) => {
            const tokenId = $(e.currentTarget).attr('data-value');
            this.deletePayment(tokenId);
        });

        if (init.startPage == 2) {
            this.loadPaymentInfo();
        }
        if (init.startPage == 3) {
            this.loadHistoryInfo();
        }
    }

    addPayment() {
        AxessViewer.loadPartialView('/Profile/AddPayment', {}, (resp: ICreateTokenResponse) => {
            if (!resp.success) {
                this.loadPaymentInfo();
                return;
            }
            window.location.href = resp.formUrl;
        }, {});
    }

    deletePayment(tokenId: string) {
        AxessViewer.loadPartialView('/Profile/DeletePayment', { tokenId: tokenId }, (resp: ICreateTokenResponse) => (
            this.loadPaymentInfo()
        ), {});
    }

    loadPaymentInfo() {
        AxessViewer.loadPartialView('/Profile/PaymentMethods', {}, (resp: { view: string }) => (
            $('#tabs_2').html(resp.view)
        ), {});
    }

    loadHistoryInfo() {
        AxessViewer.loadPartialView('/Profile/PaymentHistory', {}, (resp: { view: string }) => {
            const parsedView = $.parseHTML(resp.view, true);
            $('#tabs_3').html('').append(parsedView);
        }, {});
    }

    updateToken(membershipId: string, tokenId: string, paymentMethod) {
        AxessViewer.loadPartialView('/Profile/UpdateToken', { membershipId: membershipId, tokenId: tokenId, paymentMethod: paymentMethod }, (resp: ICreateTokenResponse) => {
            window.location.reload()
        }, {});
    }

    cancelMembership(membershipId: string) {
        AxessViewer.loadPartialView('/Profile/CancelMembershp', { membershipId: membershipId }, (resp: ICreateTokenResponse) => {
            window.location.reload()
        }, {});
    }

    getMembershipDetails(membershipId: string) {
        AxessViewer.loadPartialView('/Profile/GetMembershipDetails', { membershipId: membershipId }, (resp: IGetMembershipDetails) => {
            if (resp.success && !resp.isCancellable) {
                $(`[data-membership-cancel-button="${membershipId}"]`).removeClass('d-flex').addClass('d-none');
                $(`[data-membership-cancel-text="${membershipId}"]`).removeClass('d-none');
                $(`[data-membership-cancel-date="${membershipId}"]`).text(resp.cancelDate);
            }
            $(`[data-manage-modal="${membershipId}"]`).modal('show');
        }, {});
    }
}

interface ICreateTokenResponse {
    success: boolean;
    formUrl: string;
}

interface IGetMembershipDetails {
    success: boolean;
    isCancellable: boolean;
    cancelDate: string;
}

//data-manage-modal-button="save"